import api from './api';

// -----------------------------------------------------------------------------
// Cache in-memory (+ localStorage) del menu POS "leggero" (senza immagini base64).
// Serve a rendere l'apertura del tavolo / drawer ordine ISTANTANEA: i dati vengono
// mostrati subito dalla cache e aggiornati in background (stale-while-revalidate).
// -----------------------------------------------------------------------------
const LS_KEY = 'menuCache_v1';

let cache = { categories: null, subcategories: null, productsByChannel: {} };

// Hydration iniziale da localStorage (paint istantaneo anche al primo avvio sessione)
try {
  const raw = localStorage.getItem(LS_KEY);
  if (raw) {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object') cache = { productsByChannel: {}, ...parsed };
  }
} catch { /* noop */ }

const persist = () => {
  try { localStorage.setItem(LS_KEY, JSON.stringify(cache)); } catch { /* noop */ }
};

// Immagini prodotto (base64) tenute SOLO in memoria (troppo pesanti per localStorage).
// Caricate in background dopo il paint istantaneo e "fuse" nella griglia (lazy).
let imagesMem = {}; // { channel: { productId: {image, image_x, image_y, image_zoom} } }

export const getMenuImages = (channel = 'tavoli') => imagesMem[channel] || null;

export const refreshMenuImages = async (channel = 'tavoli') => {
  const { data } = await api.get(`/products?channel=${channel}`); // versione completa (con immagini)
  const map = {};
  (data || []).forEach((p) => {
    if (p.image) map[p.id] = { image: p.image, image_x: p.image_x, image_y: p.image_y, image_zoom: p.image_zoom };
  });
  imagesMem[channel] = map;
  return map;
};

export const getMenuCache = (channel = 'tavoli') => ({
  categories: cache.categories || [],
  subcategories: cache.subcategories || [],
  products: (cache.productsByChannel && cache.productsByChannel[channel]) || [],
  hasData: !!(cache.categories && cache.productsByChannel && cache.productsByChannel[channel]),
});

// Ricarica dal server e aggiorna la cache. Ritorna i dati freschi per il canale.
export const refreshMenuCache = async (channel = 'tavoli') => {
  const [c, p, sc] = await Promise.all([
    api.get('/categories'),
    api.get(`/products?light=true&channel=${channel}`),
    api.get('/subcategories'),
  ]);
  cache.categories = c.data || [];
  cache.subcategories = sc.data || [];
  cache.productsByChannel = { ...(cache.productsByChannel || {}), [channel]: p.data || [] };
  persist();
  return getMenuCache(channel);
};

// Prefetch "fire-and-forget": scalda la cache senza bloccare la UI.
export const prefetchMenu = (channel = 'tavoli') => { refreshMenuCache(channel).catch(() => {}); };

// Invalida la cache (es. dopo modifiche al menu).
export const clearMenuCache = () => {
  cache = { categories: null, subcategories: null, productsByChannel: {} };
  imagesMem = {};
  try { localStorage.removeItem(LS_KEY); } catch { /* noop */ }
};
